import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import Button from '../../Button'
import { ButtonIconSelectControl, ButtonSelect } from '../../Select'

import { QA_NAME_PROFILE_ADD_NEW_MENU } from './EntityProfileHeaderAddNewButton.constants'

import * as styles from './EntityProfileHeaderAddNewButton.module.css'

import PlusIcon from '../../../icons/plus.svg'

function EntityProfileHeaderAddNewButton({
  buttonProps: {
    beforeIconProps: {
      Icon: ButtonBeforeIcon = PlusIcon,
      ...buttonBeforeIconProps
    } = EMPTY_OBJECT,
    qaName: buttonQaName = QA_NAME_PROFILE_ADD_NEW_MENU,
    ...buttonProps
  } = EMPTY_OBJECT,
  buttonText = 'Profile.AddNewBtnKey',
  className = styles.EntityProfileHeaderAddNewButton,
  options = EMPTY_LIST,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <ButtonSelect
      {...restProps}
      Control={ButtonIconSelectControl}
      className={className}
      controlProps={{
        Button: Button.Contained,
        buttonProps: {
          ...buttonProps,
          beforeIconProps: { ...buttonBeforeIconProps, Icon: ButtonBeforeIcon },
          qaName: buttonQaName,
          text: t(buttonText),
        },
      }}
      filter={null}
      listProps={{
        headerProps: {
          Search: null,
        },
        itemProps: {
          contentProps: {
            infoProps: {
              contentTextProps: {
                textProps: {
                  isSecondary: true,
                },
              },
            },
          },
        },
      }}
      options={options}
    />
  )
}

export default EntityProfileHeaderAddNewButton
